export default {"src":"/_next/static/media/arrow-down.dc35a82b.svg","height":7,"width":12,"blurWidth":0,"blurHeight":0};